export enum Mark {
    NONE,
    ONE,
    TWO,
}

export interface BoardPosition {
    row: number;
    col: number;
}
